import Vue from 'vue'
import store from './store'
import axios from 'axios'
import { isAuth } from "./utils";

//引入iconfont
require('./assets/iconfont/iconfont.css');

require('./assets/css/normalize.css');
// require('./assets/css/demo.css');
// require('./assets/css/component.css');
require('./assets/css/cropper.min.css');

//全局引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss' //改变Element UI默认样式
import locale from 'element-ui/lib/locale/lang/zh-CN'

//全局通用样式
require('./assets/css/style.scss');
require('./assets/css/Home.scss');
Vue.use(ElementUI, { size: 'small' }, { locale })

import echarts from 'echarts' //引入echarts
Vue.prototype.$echarts = echarts //引入组件
Vue.prototype.isAuth = isAuth; //引入权限控制
//引入国际化
// import i18n from './i18n/i18n';

//引入滚动条插件

import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar);
//引入vue-quill-editor富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);
// //引入图片放大插件
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let option = {
    fullscreenEl: false,
};
Vue.use(preview, option);

//引用viewer图片放大功能
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
    defaultOptions: {
        'inline': false,
        'button': true,
        'navbar': false,
        'title': false,
        'zoomRatio': 0.1,
        'maxZoomRatio': 4,
        'minZoomRatio': 0.1,
    }
});
//引入swiper轮播插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

// 全局滤镜 filters
import * as filters from './filters'
// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})


Date.prototype.Format = function(fmt) {
        var o = {
            "M+": this.getMonth() + 1, // 月份
            "d+": this.getDate(), // 日
            "h+": this.getHours(), // 小时
            "m+": this.getMinutes(), // 分
            "s+": this.getSeconds(), // 秒
            "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
            "S": this.getMilliseconds() // 毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + ""));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }
    // 计算文字填充处长度，js解决两行显示省略号问题
Vue.prototype.textSize = function(fontSize, fontFamily, text) {
    var span = document.createElement("span");
    var result = {};
    result.width = span.offsetWidth;
    result.height = span.offsetHeight;
    span.style.visibility = "hidden";
    span.style.fontSize = fontSize;
    span.style.fontFamily = fontFamily;
    span.style.display = "inline-block";
    document.body.appendChild(span);
    if (typeof span.textContent != "undefined") {
        span.textContent = text;
    } else {
        span.innerText = text;
    }
    result.width = parseFloat(window.getComputedStyle(span).width) - result.width;
    result.height = parseFloat(window.getComputedStyle(span).height) - result.height;
    return result;
}

//设置页面标题
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
// new Vue({
//     el: '#app',
//     router,
//     store,
//     i18n,
//     render: h => h(App)
// })
axios.get('static/urlconfig/serverConfig.json').then(res => {
    Vue.prototype.urlArr = res.data;
    new Vue({
        el: '#app',
        router,
        store,
        // i18n, 
        render: h => h(App)
    })
})
import App from './App'
import router from './router'


// WEBPACK FOOTER //
// ./src/main.js